import React from 'react';

const ApprovalManagerSuperAdmin = () => {
    return (
        <div>
            <h3 style={{ fontSize: "20px", fontWeight: "400", color: "#000000", marginTop: "20px", marginBottom: "10px" }}>
                How the approval manager is added?
            </h3>

            <p className="description">
                This section provides a detailed explanation of managing Approval Manager data, including adding a new Approval Manager and editing an existing one.
            </p>

            <img
                className="placeholder-image image_gatnix_support"
                src="https://res.cloudinary.com/danfpnuui/image/upload/v1740691243/WhatsApp_Image_2025-02-28_at_12.49.53_AM_f3stuc.jpg"
                alt="Approval Manager Screenshot"
                style={{width : "60%"}}
            />

            <h3 className="subheading">Add Approval Manager</h3>
            <p className="description">
                Click on the "Add Approval Manager" button to open the above form. This form allows you to fill in details like First Name, Last Name, Email, Password, Mobile Number, and WhatsApp Number. After filling in the details, click the <strong>Save</strong> button to add the Approval Manager.
            </p>

            <img
                className="placeholder-image image_gatnix_support"
                src="https://res.cloudinary.com/danfpnuui/image/upload/v1740691611/WhatsApp_Image_2025-02-26_at_9.37.22_PM_psi9fn.jpg"
                alt="Edit Approval Manager Screenshot"
                style={{width :"60%"}}
            />

            <p className="description">
                To edit an Approval Manager's details, click the "Edit" button in the corresponding row. This opens a form pre-filled with the existing details of the selected manager. After making the necessary changes, click <strong>Save</strong> to update the information.
            </p>

            <h3 className="subheading">Save or Cancel</h3>
            <p className="description">
                Once the form is filled, you can either click <strong>Save</strong> to submit the changes or <strong>Cancel</strong> to discard them and close the form.
            </p>

            <h3 className="subheading">Tips</h3>
            <ul className="tips">
                <li>Ensure the email address is valid and active.</li>
                <li>Use a strong password with a mix of letters, numbers, and symbols.</li>
                <li>Double-check the mobile and WhatsApp numbers before saving.</li>
            </ul>

            <h3 className="subheading">Notes</h3>
            <ul className="notes">
                <li>All fields are required.</li>
                <li>The Approval Manager will receive a confirmation email after being added.</li>
            </ul>

            <style jsx>{`
                .heading {
                    font-size: 24px;
                    font-weight: 300;
                    color: #000000;
                    margin-bottom: 10px;
                }

                .description {
                    font-size: 16px;
                    line-height: 1.6;
                    color: #4f4f4f;
                    margin-bottom: 20px;
                }

                .subheading {
                    font-size: 20px;
                    font-weight: 300;
                    color: #000000;
                    margin-bottom: 10px;
                }

                .placeholder-image {
                    width: 100%;
                    height: auto;
                    margin-bottom: 20px;
                }

                .tips,
                .notes {
                    font-size: 16px;
                    color: #4f4f4f;
                    margin-left: 20px;
                }

                .tips li,
                .notes li {
                    margin-bottom: 5px;
                }

                @media (max-width: 768px) {
                    .heading {
                        font-size: 20px;
                    }

                    .subheading {
                        font-size: 18px;
                    }

                    .description {
                        font-size: 14px;
                    }
                }

                @media (max-width: 480px) {
                    .heading {
                        font-size: 18px;
                    }

                    .subheading {
                        font-size: 16px;
                    }

                    .description {
                        font-size: 12px;
                    }
                }
            `}</style>
        </div>
    );
};

export default ApprovalManagerSuperAdmin;
